import { useQuery } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useUser from "hooks/useUser";
import GET_ME from "queries/getMe";
import { useHistory } from "react-router-dom";
import Profile from "./Profile";
const usePrepareComponent = () => {
    const history = useHistory();
    const { onClearToken } = useUser();
    const { data } = useQuery(GET_ME);
    const onLogout = () => {
        onClearToken();
        history.push("/login");
    };
    return {
        me: data?.me,
        onLogout
    };
};
export default prepareComponent(usePrepareComponent)(Profile);
